var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"popup-owners__text-list"},_vm._l((_vm.list),function(item){return _c('li',{key:item.id,staticClass:"popup-owners__text-item"},[_vm._v("\n        "+_vm._s(item.title)+"\n        "),_c('span',{domProps:{"innerHTML":_vm._s(item.note)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }